var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.signMessage)?_c('base-material-alert',{staticClass:"mb-7",class:{
    'secondary--text': !_vm.$vuetify.theme.dark,
    'white--text': _vm.$vuetify.theme.dark,
  },attrs:{"color":"softInfo"}},[_c('span',{staticClass:"sign-card-message"},[_vm._v(" "+_vm._s(_vm.$t(("views.sign." + _vm.signMessage)))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }